import React from "react";

import "../../../assets/css/footer/MentionsLegales.css";



export default function MentionsLegales() {

  return (

    <main className="ml-wrap">

      <article className="ml-card">

        <h1>Mentions légales - DEAL.MG</h1>

        <p className="ml-sub">

          Informations légales, hébergement, responsabilité, données personnelles.

        </p>



        <section className="ml-sec">

          <h2>1. Éditeur du site</h2>



          <div className="ml-kv">

            <div className="ml-k">Société</div>

            <div>Deal.mg SARL</div>



            <div className="ml-k">Forme</div>

            <div>Société à Responsabilité Limitée (SARL)</div>



            <div className="ml-k">Capital social</div>

            <div>1 000 000 Ariary</div>



            <div className="ml-k">Siège social</div>

            <div>Rue Ratsimilaho, 101 Antananarivo, Madagascar</div>



            <div className="ml-k">RCS</div>

            <div>2026B00236</div>



            <div className="ml-k">NIF</div>

            <div>6019573963</div>



            <div className="ml-k">Numéro STAT</div>

            <div>62011 11 2026 0 10233</div>



            <div className="ml-k">Directeur de la publication</div>

            <div>Abdealy</div>



            <div className="ml-k">Email</div>

            <div>

              <a href="mailto:contact@deal.mg">contact@deal.mg</a>

            </div>

          </div>

        </section>



        <section className="ml-sec">

          <h2>2. Hébergement</h2>

          <p>

            <strong>Infomaniak Network SA</strong>

            <br />

            Rue Eugène-Marziano 25

            <br />

            1227 Les Acacias (Genève)

            <br />

            Suisse

            <br />

            Site :{" "}

            <a

              href="https://www.infomaniak.com"

              target="_blank"

              rel="noopener noreferrer"

            >

              https://www.infomaniak.com

            </a>

          </p>

        </section>



        <section className="ml-sec">

          <h2>3. Nature du service</h2>

          <p>

            Deal.mg est une plateforme de petites annonces permettant la mise en relation

            entre vendeurs et acheteurs. La société éditrice agit exclusivement en qualité

            d’intermédiaire technique. Elle ne vend aucun produit, ne stocke aucun produit,

            n’intervient pas dans les transactions et n’assure pas la livraison entre utilisateurs.

          </p>

        </section>



        <section className="ml-sec">

          <h2>4. Limitation de responsabilité</h2>

          <p>Deal.mg ne peut être tenu responsable :</p>

          <ul>

            <li>d’une arnaque entre utilisateurs,</li>

            <li>d’un défaut produit, d’un produit contrefait, d’un vice caché,</li>

            <li>d’un non-paiement, d’une escroquerie bancaire,</li>

            <li>d’une usurpation d’identité ou d’un contenu frauduleux publié par un utilisateur.</li>

          </ul>

          <p>Chaque utilisateur agit sous sa propre responsabilité.</p>

        </section>



        <section className="ml-sec">

          <h2>5. Propriété intellectuelle</h2>

          <p>

            L’ensemble des éléments présents sur le site (nom, logo, design, base de données,

            code source, textes, images) est protégé par le droit de la propriété intellectuelle.

            Toute reproduction ou exploitation sans autorisation écrite est interdite.

          </p>

        </section>



        <section className="ml-sec">

          <h2>6. Données personnelles</h2>

          <p>

            Les données collectées sont utilisées uniquement pour la gestion des comptes,

            la sécurisation de la plateforme, la lutte contre la fraude et la gestion des services payants.

            Les données ne sont ni vendues ni cédées à des tiers.

          </p>

        </section>



        <section className="ml-sec">

          <h2>7. Signalement de contenu</h2>

          <p>

            Tout contenu suspect ou illégal peut être signalé à :{" "}

            <a href="mailto:contact@deal.mg">contact@deal.mg</a>. La société se réserve

            le droit de retirer sans préavis tout contenu contraire à la loi ou aux CGU.

          </p>

        </section>



        <section className="ml-sec">

          <h2>8. Lutte contre la fraude</h2>

          <p>

            La société peut suspendre ou supprimer un compte suspect, conserver les données de

            connexion et transmettre les informations aux autorités compétentes.

          </p>

        </section>



        <section className="ml-sec">

          <h2>9. Droit applicable</h2>

          <p>

            Les présentes mentions légales sont soumises au droit malgache. Tout litige relève

            de la compétence exclusive des tribunaux d’Antananarivo.

          </p>

        </section>

      </article>

    </main>

  );

}